import React, { getGlobal } from "reactn";
import { Button, CircularProgress, ButtonGroup } from "@material-ui/core/";
import * as API from "../../../api/api";

export default class ActieKnoppen extends React.Component {
  user = getGlobal();

  _mounted = false;
  _timeouts = [];

  state = {
    buttonsDisabled: false,
    status: undefined,
    vullenLoading: false,
    legenLoading: false,
    resetLoading: false
  };

  componentDidMount() {
    this._mounted = true;
    this.setState({ status: this.props.status });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status) {
      this.setState({ status: this.props.status });
    }
  }

  componentWillUnmount() {
    this._mounted = false;
    // alle timeouts opruimen
    this._timeouts.forEach(clearTimeout);
    this._timeouts = [];
  }

  // helper om setState veilig te doen
  safeSetState = (next) => {
    if (!this._mounted) return;
    this.setState(next);
  };

  // helper om een timeout te registreren die we later kunnen clearen
  addTimeout = (fn, ms) => {
    const id = setTimeout(fn, ms);
    this._timeouts.push(id);
    return id;
  };

  vullenDisabled = (code) => {
    const disabledCodes = [2, 4, 5, 7, 9, 19, 21];
    return disabledCodes.includes(code);
  };

  legenDisabled = (code) => {
    const disabledCodes = [3, 6, 8, 19, 21];
    return disabledCodes.includes(code);
  };

  resetDisabled = (code) => {
    if ((code > 9 || code === 1) && code !== 19) {
      return false;
    }
    return true;
  };

  handleVullen = async () => {
    const deviceHash = this.user?.user?.device_hash;
    const { networkID, nummer } = this.props;
    console.log(`VULLEN => device=${deviceHash} | networkID=${networkID} | nummer=${nummer}`);

    this.safeSetState({ vullenLoading: true });

    try {
      if (deviceHash) {
        await API.doFill(deviceHash, networkID, parseInt(nummer));
        console.log("VULLEN: API.doFill voltooid");
      } else {
        console.warn("VULLEN: deviceHash ontbreekt, request niet verstuurd");
      }
    } catch (err) {
      console.error("VULLEN: fout bij API.doFill", err);
    } finally {
      this.addTimeout(() => this.safeSetState({ vullenLoading: false }), 100);
    }
  };

  handleLegen = async () => {
    const deviceHash = this.user?.user?.device_hash;
    const { networkID, nummer } = this.props;
    console.log(`LEGEN => device=${deviceHash} | networkID=${networkID} | nummer=${nummer}`);

    this.safeSetState({ legenLoading: true });

    try {
      if (deviceHash) {
        await API.doEmpty(deviceHash, networkID, parseInt(nummer));
        console.log("LEGEN: API.doEmpty voltooid");
      } else {
        console.warn("LEGEN: deviceHash ontbreekt, request niet verstuurd");
      }
    } catch (err) {
      console.error("LEGEN: fout bij API.doEmpty", err);
    } finally {
      this.addTimeout(() => this.safeSetState({ legenLoading: false }), 100);
    }
  };

  handleSetReset = async () => {
    const deviceHash = this.user?.user?.device_hash;
    const { networkID, nummer } = this.props;
    console.log(`RESET => device=${deviceHash} | networkID=${networkID} | nummer=${nummer}`);

    this.safeSetState({ resetLoading: true });

    try {
      if (deviceHash) {
        await API.doSetReset(deviceHash, networkID, parseInt(nummer));
        console.log("RESET: API.doSetReset voltooid");
      } else {
        console.warn("RESET: deviceHash ontbreekt, request niet verstuurd");
      }
    } catch (err) {
      console.error("RESET: fout bij API.doSetReset", err);
    } finally {
      this.addTimeout(() => this.safeSetState({ resetLoading: false }), 100);
    }
  };

  render() {
    const { vullenLoading, legenLoading, resetLoading } = this.state;

    return (
      <>
        <ButtonGroup variant="contained" style={{ width: "100%" }}>
          <Button
            color="primary"
            variant="contained"
            onClick={this.handleVullen}
            style={{ width: "50%" }}
            disabled={vullenLoading || this.vullenDisabled(this.props.status)}
          >
            {vullenLoading ? (
              <CircularProgress size={23} thickness={4} />
            ) : (
              "Vullen"
            )}
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={this.handleLegen}
            disabled={legenLoading || this.legenDisabled(this.props.status)}
            style={{ width: "50%" }}
          >
            {legenLoading ? (
              <CircularProgress size={23} thickness={4} />
            ) : (
              "Legen"
            )}
          </Button>
          {this.user?.user?.admin && (
            <Button
              color="secondary"
              variant="contained"
              onClick={this.handleSetReset}
              disabled={resetLoading || this.resetDisabled(this.props.status)}
              style={{ width: "50%" }}
            >
              {resetLoading ? (
                <CircularProgress size={23} thickness={4} />
              ) : (
                "Reset"
              )}
            </Button>
          )}
        </ButtonGroup>
      </>
    );
  }
}
